"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValueOrNull = exports.getContentHeight = void 0;
var _constants = require("./constants");
const getContentHeight = (lineHeight, fontSize) => {
  let contentHeight = _constants.DEFAULT_LINE_HEIGHT;
  if (lineHeight) {
    if (typeof lineHeight === 'string') {
      // extracting number from lineHeight value
      const [, lineHeightValue] = lineHeight.split(/^(\d+(?:\.\d+)?)(.*)$/);
      contentHeight = Number(lineHeightValue);
      if (lineHeight.includes('px')) {
        return contentHeight;
      }
    } else {
      contentHeight = lineHeight;
    }
  }
  if (typeof fontSize === 'string') {
    // extracting number from fontSize value
    const [, fontSizeValue] = fontSize.split(/^(\d+(?:\.\d+)?)(.*)$/);
    contentHeight *= Number(fontSizeValue);
    if (fontSize.includes('em')) {
      contentHeight *= _constants.EM_TO_PX_RATIO;
    }
  } else {
    contentHeight *= Number(fontSize);
  }
  return contentHeight;
};
exports.getContentHeight = getContentHeight;
const getValueOrNull = (object, key) => {
  if (object && object.hasOwnProperty(key) && object[key].length > 0) {
    return object[key];
  }
  return null;
};
exports.getValueOrNull = getValueOrNull;